module.exports = __webpack_public_path__ + "static/media/nad-viso-hp50.41ed5b58.jpg";